export default "__VITE_ASSET__DYQMhbgM__"